import * as React from 'react';
import { cn } from '@/utils';

export interface TextareaProps extends Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, 'placeholder'> {
  ref?: React.ForwardedRef<HTMLTextAreaElement>;
  placeholder?: React.ReactNode | string;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, placeholder, ...props }, ref) => {
  return (
    <div className="relative w-full">
      <textarea
        className={cn(
          'flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        ref={ref}
        placeholder={typeof placeholder === 'string' ? placeholder : undefined}
        {...props}
      />
      {!props.value && !props.defaultValue && placeholder && typeof placeholder !== 'string' && (
        <div className="absolute inset-0 px-3 py-2 pointer-events-none" onClick={(e) => e.stopPropagation()}>
          {placeholder}
        </div>
      )}
    </div>
  );
});
Textarea.displayName = 'Textarea';

export { Textarea };
